import React, { useState } from "react";
import { Button, makeStyles } from "@material-ui/core";

import GitHubIcon from "@material-ui/icons/GitHub";
import LinkIcon from "@material-ui/icons/Link";
const useStyles = makeStyles((theme) => ({
    project: {
        width: "27%",
        margin: "40px 50px 30px 0",
        position: "relative",
        border: "1px solid #cfcfcf",
        top: "0",
        borderRadius: "0 0 10px 10px",
        boxShadow: "0 1px 8px 2px rgba(107, 107, 107 ,0.1)",
        transition: "0.3s ease",
        [theme.breakpoints.down("md")]: {
            width: "37%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "320px",
        },
        [theme.breakpoints.down("xs")]: {
            marginRight: "0",
            width: "300px",
        },

        "&:hover": {
            cursor: "pointer",

            top: "-5px",

            boxShadow: "0 1px 8px 2px rgba(107, 107, 107 ,0.2)",
        },
    },
    description: {
        padding: "15px",
    },
    buttonGroup: {
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "20px",
    },
    btn: {
        width: "130px",
        fontSize: "13px",

        outline: "none",
        color: "white",
        backgroundColor: "#05a7b0",
        "&:hover": {
            backgroundColor: "teal",
        },
    },
    title: {
        fontWeight: "500",
        fontSize: "17px",
        marginBottom: "10px",
    },
    tags: {
        display: "flex",
        flexWrap: "wrap",
    },
    tag: {
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        marginTop: "10px",
        marginRight: "10px",
        fontSize: "13px",
        color: "teal",
    },
    aboutProject: {
        marginTop: "20px",
        marginBottom: "15px",
        opacity: "0.9",
        lineHeight: "30px",
    },
    readMore: {
        fontSize: "12px",
        color: "teal",
        cursor: "pointer",
    },
    icon: {
        fontSize: "18px",
        marginLeft: "10px",
    },
}));
function Projectcard({ project }) {
    const classes = useStyles();
    const [Readmore, setReadmore] = useState(false);

    let ReadMoreClicked = () => {
        setReadmore((prev) => !prev);
    };
    return (
        <div className={classes.project}>
            <div className={classes.image}>
                <a href={project.projectLink} target="_blank">
                    <img
                        src={project.image}
                        width="100%"
                        style={{ height: "158px", objectFit: "cover" }}
                    ></img>
                </a>
            </div>
            <div className={classes.description}>
                <div
                    className={classes.title}
                    onClick={() => window.open(project.projectLink)}
                >
                    {project.title}
                </div>
                {project.tags ? (
                    <div className={classes.tags}>
                        {project.tags.map((tag) => {
                            return <div className={classes.tag}>{tag}</div>;
                        })}
                    </div>
                ) : null}
                <div className={classes.aboutProject}>
                    {project.description.length > 120 && !Readmore ? (
                        <>
                            {`${project.description.substring(0, 120)}.... `}
                            <span
                                className={classes.readMore}
                                onClick={ReadMoreClicked}
                            >
                                Read More
                            </span>{" "}
                        </>
                    ) : Readmore ? (
                        <>
                            {" "}
                            {project.description}{" "}
                            <span
                                className={classes.readMore}
                                onClick={ReadMoreClicked}
                            >
                                Read Less
                            </span>
                        </>
                    ) : (
                        project.description
                    )}
                </div>
            </div>
            <div className={classes.buttonGroup}>
                <a
                    href={project.projectLink}
                    style={{ textDecoration: "none" }}
                    target="_blank"
                >
                    <Button className={classes.btn}>
                        Go Live <LinkIcon className={classes.icon} />{" "}
                    </Button>
                </a>
                {project.github && (
                    <a
                        href={project.github}
                        style={{ textDecoration: "none" }}
                        target="_blank"
                    >
                        <Button className={classes.btn}>
                            Project
                            <GitHubIcon className={classes.icon} />
                        </Button>
                    </a>
                )}
            </div>
        </div>
    );
}

export default Projectcard;
